import React from 'react';

interface ModalProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  contentLabel: string;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ showModal, setShowModal, contentLabel, children }) => {
  if (!showModal) return null;

  return (
    <div className="custom-modal">
      <div className="custom-modal-content">
        {contentLabel && <h3>{contentLabel}</h3>}
        <div>{children}</div>
        <button onClick={() => setShowModal(false)} className="custom-close-button">Close</button>
      </div>
    </div>
  );
};

export default Modal;
